module.exports = __webpack_public_path__ + "img/service2_content.08131ea4.png";